const badgeLibraryReducer = (
  state = {
    chosen_image: '',
    index: '',
  },
  action
) => {
  switch (action.type) {
    case "SET_CHOSEN_BADGE":
      return {
        chosen_image: action.payload.chosen_image,
        index: action.payload.index,
      };
    default:
      return state;
  }
};

export default badgeLibraryReducer;
